<template>
  <v-navigation-drawer
    v-model="dialog"
    right
    class="navigation-drawer"
    width="400"
    persistent
    :fullscreen="$vuetify.breakpoint.xsAndDown"
    app
  >
    <template v-slot:prepend>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>Documento</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('close')">mdi-close</v-icon>
      </v-toolbar>
    </template>

    <v-card>
      <v-card-text class="pa-0 text-center">
        <v-img :src="invoiceImg" v-if="invoiceImg"></v-img>
        <!-- QR ahora está integrado dentro del canvas de invoiceImg -->
        <br /><br /><br /><br />
      </v-card-text>
    </v-card>

    <template v-slot:append>
      <v-toolbar class="fixed-footer">
        <v-btn color="grey" @click="handlePrintLabels">
          <v-icon>mdi-label-outline</v-icon> Labels
        </v-btn>
        <v-spacer></v-spacer>

        <!-- Componente PDF Profesional para Órdenes de Compra -->
        <ProfessionalPDFGenerator
          v-if="isPurchaseOrder"
          :documentData="item"
          @pdf-generated="onPDFGenerated"
          @pdf-error="onPDFError"
        />
        <v-spacer></v-spacer>
        <v-btn color="info" @click="print_doc()" :disabled="!invoiceImg">
          <v-icon left>mdi-printer</v-icon>
          Imprimir
        </v-btn>
      </v-toolbar>
    </template>

    <label-printer
      v-model="showLabelPrinter"
      :items="labels"
      @labels-printed="onLabelsPrinted"
    />

    <!-- Loading mientras se genera la imagen -->
    <v-dialog v-model="loading_status" hide-overlay persistent>
      <v-card color="primary" dark>
        <v-card-text class="pa-6">
          <p>Generando documento...</p>
          <v-progress-linear indeterminate color="green" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { webserver, formatCurrency } from "@/services/webserver.js";
import settings from "../utils/settings.js";
import ProfessionalPDFGenerator from "./InvoicePDFGenerator.vue";
import LabelPrinter from "@/components/LabelPrinter.vue";

var QRCode = require("qrcode");

export default {
  components: {
    ProfessionalPDFGenerator,
    LabelPrinter,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        document: { doc_number: "N/A" },
        buyer: {},
        items: [],
        payments: [],
        company: {},
        seller: {},
      }),
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      showLabelPrinter: false,
      labels: [],
      invoiceImg: null,
      urlCufe: null,
      loading_status: false,
      settings: settings(),
    };
  },

  computed: {
    isPurchaseOrder() {
      return this.item?.document?.doc_type === "OP";
    },
  },

  methods: {
    handlePrintLabels() {
      console.log(this.item.document);
      this.get_labels(this.item.document);
    },
    async get_labels(e) {
      const doc = {
        store: e.store,
        issueDate: e.issuedate,
        did: e.doc_number,
      };

      this.loading_status = true;
      this.lStatus = "Cargando documento...";

      webserver("get_invoice_items", doc, (data) => {
        console.log(data);
        const items = data.data;
        items.forEach((item) => {
          item.cantidad = parseInt(item.cantidad) || 1;
          item.precio = parseFloat(item.precio) || 0;
          item.costo = parseFloat(item.costo) || 0;
        });

        this.loading_status = false;
        if (items) {
          this.labels = items;
          this.showLabelPrinter = true;
        }
      });
    },
    onLabelsPrinted(data) {
      console.log("Etiquetas impresas:", data);
      this.labels = []; // Limpiar selección si deseas
    },
    // Eventos del generador de PDF profesional
    onPDFGenerated(result) {
      this.$emit("show-message", {
        text: `PDF profesional generado: ${result.fileName}.pdf`,
        color: "success",
        timeout: 4000,
      });
    },

    onPDFError(error) {
      console.error("Error generando PDF profesional:", error);
      this.$emit("show-message", {
        text: "Error al generar el PDF profesional",
        color: "error",
        timeout: 4000,
      });
    },
    formatCurrency,

    // ✅ AGREGADO: Método formatAmount para consistencia
    formatAmount(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    print_doc() {
      if (!this.invoiceImg) {
        console.warn("No hay imagen disponible para imprimir");
        return;
      }

      var printWindow = window.open("", "", "height=600, width=400");
      printWindow.document.write(
        "<html><head><title>Imprimir Documento</title></head><body>"
      );

      // Solo imprimir la imagen del canvas (que ya incluye el QR integrado)
      printWindow.document.write(
        '<img src="' + this.invoiceImg + '" style="width: 100%; max-width: 100%;"/><br>'
      );

      // QR ya está integrado en el canvas, no necesitamos imprimirlo por separado

      printWindow.document.write("</body></html>");
      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        setTimeout(() => {
          printWindow.close();
        }, 500);
      }, 800);
    },

    print_invoice(data) {
      this.loading_status = true;

      try {
        if (!data || !data.items || !Array.isArray(data.items)) {
          console.warn("Datos insuficientes para generar la imagen");
          this.loading_status = false;
          return;
        }

        var url_cufe =
          "https://catalogo-vpfe-hab.dian.gov.co/document/searchqr?documentkey=";

        if (data.company && data.company.environment === "1") {
          url_cufe = "https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=";
        }

        // Helper function para envolver texto
        const wrapText = (ctx, text, maxWidth) => {
          const words = text.split(" ");
          const lines = [];
          let currentLine = words[0];

          for (let i = 1; i < words.length; i++) {
            const word = words[i];
            const width = ctx.measureText(currentLine + " " + word).width;
            if (width < maxWidth) {
              currentLine += " " + word;
            } else {
              lines.push(currentLine);
              currentLine = word;
            }
          }
          lines.push(currentLine);
          return lines;
        };

        var LS = 50;
        var itemsQty = data.items.length * LS;
        var elem = document.createElement("canvas");
        elem.width = 945;
        elem.height = 3000 + itemsQty * 3;
        var center = elem.width / 2;
        var left = 10;
        var line = 150;
        var right = elem.width - left;
        const ctx = elem.getContext("2d");

        // ✅ ARREGLO: Usar fuentes monospace consistentes como en doc_viewer.vue
        const titleFont =
          "bold 60px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const headerFont =
          "bold 40px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const normalFont =
          "bold 38px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const smallFont =
          "bold 35px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";

        var items = data.items || [];

        // Asegurar que los items tengan valores numéricos
        items.forEach((item) => {
          item.item_quantity = parseInt(item.item_quantity) || 1;
          item.item_price = parseFloat(item.item_price) || 0;
          item.item_discount = parseFloat(item.item_discount) || 0;
        });

        var regimen = "NO RESPONSABLES DEL IVA";
        if (data.seller && data.seller.TaxLevelCode === "1") {
          regimen = "RESPONSABLES DEL IVA";
        }

        // ✅ ARREGLO: Header consistente con doc_viewer.vue
        ctx.font = titleFont;
        ctx.textAlign = "center";
        ctx.fillText(
          (data.seller && data.seller.PartyIdentification_Id) || "N/A",
          center,
          line
        );
        line += LS;

        ctx.font = headerFont;
        ctx.fillText((data.seller && data.seller.PartyName) || "EMPRESA", center, line);
        line += LS;

        ctx.fillText(regimen, center, line);
        line += LS;

        if (data.company && data.company.AddressLine) {
          ctx.font = normalFont;
          ctx.fillText(data.company.AddressLine, center, line);
          line += LS;
        }

        // Información del documento
        ctx.font = headerFont;
        switch ((data.document && data.document.doc_type) || "invoice") {
          case "OP":
            line += LS;
            ctx.fillText("ORDEN DE COMPRA", center, line);
            line += LS;
            ctx.font = headerFont;
            ctx.fillText(
              "No. " + ((data.document && data.document.invoice) || "N/A"),
              center,
              line
            );
            break;
          case "invoice":
            line += LS;
            ctx.fillText("FACTURA ELECTRONICA DE VENTA", center, line);
            ctx.font = headerFont;
            line += LS;
            ctx.fillText(
              "No. " + ((data.document && data.document.invoice) || "N/A"),
              center,
              line
            );
            break;
          case "pos":
            line += LS;
            ctx.fillText("DOCUMENTO EQUIVALENTE", center, line);
            line += LS;
            ctx.fillText("A LA FACTURA DE VENTA", center, line);
            line += LS;
            ctx.fillText("SISTEMA POS", center, line);
            ctx.font = headerFont;
            line += LS;
            ctx.fillText(
              "No. " + ((data.document && data.document.invoice) || "N/A"),
              center,
              line
            );
            break;
          case "NC":
            line += LS;
            ctx.fillText("NOTA CREDITO", center, line);
            ctx.font = headerFont;
            line += LS;
            ctx.fillText(
              "No. " + ((data.document && data.document.doc_number) || "N/A"),
              center,
              line
            );
            break;
        }

        line += LS;
        ctx.font = normalFont;
        ctx.fillText(
          (data.document && data.document.issuedate) || new Date().toLocaleDateString(),
          center,
          line
        );
        line += LS;

        // Línea separadora
        ctx.beginPath();
        ctx.moveTo(left, line - 10);
        ctx.lineTo(right, line - 10);
        ctx.stroke();

        line += LS;
        ctx.textAlign = "start";
        ctx.font = normalFont;

        // Información del cliente
        if (data.buyer && data.buyer.PartyIdentification) {
          ctx.fillText("Cliente: " + data.buyer.PartyIdentification, left, line);
          line += LS;
        }

        ctx.font = headerFont;
        line += LS;
        ctx.fillText((data.buyer && data.buyer.PartyName) || "CLIENTE", left, line);

        if (data.buyer && data.buyer.PartyEmail) {
          line += LS;
          ctx.font = normalFont;
          ctx.fillText("Email: " + data.buyer.PartyEmail, left, line);
        }

        line += LS;
        line += LS;
        LS = 60;

        // Productos
        ctx.font = headerFont;
        ctx.textAlign = "center";
        ctx.fillText("Productos", center, line);
        line += LS;

        ctx.beginPath();
        ctx.moveTo(left, line - 10);
        ctx.lineTo(right, line - 10);
        ctx.stroke();
        line += LS;

        // ✅ ARREGLO: Inicializar variables para discriminación de impuestos como en doc_viewer.vue
        var breakdown = {
          base_0: 0, // Base gravable tarifa 0%
          base_5: 0, // Base gravable tarifa 5%
          base_8: 0, // Base gravable tarifa 8% (INC)
          base_19: 0, // Base gravable tarifa 19%
          base_other: 0, // Otras tarifas
          tax_0: 0, // IVA 0%
          tax_5: 0, // IVA 5%
          tax_8: 0, // INC 8%
          tax_19: 0, // IVA 19%
          tax_other: 0, // Otros impuestos
          total_base: 0,
          total_tax: 0,
          total_discount: 0,
        };

        var idx = 1;
        ctx.textAlign = "start";
        ctx.font = normalFont;
        ctx.fillText("Item", left, line);
        ctx.fillText("Detalle", left + 120, line);
        ctx.textAlign = "end";
        ctx.fillText("Cant.", right - 200, line);
        // ✅ NUEVO: Cabecera dinámica según tipo de documento
        if ((data.document && data.document.doc_type) === "OP") {
          ctx.fillText("Costo", right, line);
        } else {
          ctx.fillText("Valor", right, line);
        }

        line += LS;

        // ✅ ARREGLO: Procesar items con discriminación de impuestos como en doc_viewer.vue
        items.forEach((row) => {
          // ✅ NUEVO: Para órdenes de compra usar COSTO, para otros usar PRECIO
          let itemPrice;
          if ((data.document && data.document.doc_type) === "OP") {
            // Orden de compra: usar costo
            itemPrice = parseFloat(row.item_cost || row.costo || 0);
          } else {
            // Facturas y otros: usar precio de venta
            itemPrice = parseFloat(row.item_price || 0);
          }

          let basePrice = itemPrice - (row.item_tax || 0);
          let taxAmount = row.item_tax || 0;
          let quantity = row.item_quantity || 1;
          let discount = (row.item_discount || 0) * quantity;

          let itemTotalBasePrice = basePrice * quantity;
          let itemTotalTax = taxAmount * quantity;

          // Calcular tasa de impuesto
          let taxRate = basePrice > 0 ? Math.round((taxAmount / basePrice) * 100) : 0;

          // Clasificar por tasa de impuesto para el breakdown
          switch (taxRate) {
            case 0:
              breakdown.base_0 += itemTotalBasePrice;
              breakdown.tax_0 += itemTotalTax;
              break;
            case 5:
              breakdown.base_5 += itemTotalBasePrice;
              breakdown.tax_5 += itemTotalTax;
              break;
            case 8:
              breakdown.base_8 += itemTotalBasePrice;
              breakdown.tax_8 += itemTotalTax;
              break;
            case 19:
              breakdown.base_19 += itemTotalBasePrice;
              breakdown.tax_19 += itemTotalTax;
              break;
            default:
              breakdown.base_other += itemTotalBasePrice;
              breakdown.tax_other += itemTotalTax;
          }

          breakdown.total_base += itemTotalBasePrice;
          breakdown.total_tax += itemTotalTax;
          breakdown.total_discount += discount;

          ctx.textAlign = "start";
          ctx.fillText(idx, left, line);

          // Texto del producto con wrap
          const maxWidth = right - (left + 375);
          const concept = row.item_concept || `Producto ${idx}`;
          const wrappedLines = wrapText(ctx, concept, maxWidth);

          wrappedLines.forEach((wrappedLine, index) => {
            ctx.fillText(wrappedLine, left + 50, line + index * 35);
          });

          const conceptHeight = wrappedLines.length * 35;

          ctx.textAlign = "end";
          ctx.fillText(quantity, right - 200, line);

          line += Math.max(LS, conceptHeight);

          // Código del producto
          ctx.font = smallFont;
          ctx.textAlign = "start";
          ctx.fillText("Cod: " + (row.item_code || "N/A"), left + 50, line);
          ctx.textAlign = "end";
          // ✅ ARREGLO: Usar formatAmount en lugar de toLocaleString
          ctx.fillText(this.formatAmount(itemTotalBasePrice), right, line);

          // ✅ NUEVO: Mostrar indicador de precio usado
          if ((data.document && data.document.doc_type) === "OP") {
            ctx.font = smallFont;
            ctx.textAlign = "start";
            ctx.fillText(
              `Costo unitario: ${this.formatAmount(itemPrice)}`,
              left + 50,
              line + 30
            );
            line += 35;
          }

          line += LS;

          // ✅ ARREGLO: Mostrar detalle de impuestos como en doc_viewer.vue
          if (taxAmount > 0 && basePrice > 0) {
            ctx.font = smallFont;
            ctx.textAlign = "start";

            // Formato genérico por porcentaje
            let taxText = `Impuesto ${taxRate}%: ${this.formatAmount(itemTotalTax)}`;

            if (discount > 0) {
              taxText += ` / Desc: ${this.formatAmount(discount)}`;
            }

            ctx.fillText(taxText, left + 50, line);
            line += LS;
          } else if (discount > 0) {
            ctx.font = smallFont;
            ctx.textAlign = "start";
            ctx.fillText(`Descuento: ${this.formatAmount(discount)}`, left + 50, line);
            line += LS;
          }

          ctx.font = normalFont;
          idx += 1;
        });

        // ✅ ARREGLO: Totales con discriminación completa como en doc_viewer.vue
        ctx.beginPath();
        ctx.moveTo(left, line - 10);
        ctx.lineTo(right, line - 10);
        ctx.stroke();
        line += LS;

        ctx.font = headerFont;

        // Mostrar bases gravables por tarifa
        if (breakdown.base_0 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Base gravable 0%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.base_0), right, line);
          line += LS;
        }

        if (breakdown.base_5 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Base gravable 5%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.base_5), right, line);
          line += LS;
        }

        if (breakdown.base_8 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Base gravable 8%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.base_8), right, line);
          line += LS;
        }

        if (breakdown.base_19 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Base gravable 19%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.base_19), right, line);
          line += LS;
        }

        // Subtotal base gravable
        if (breakdown.total_base > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Subtotal", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.total_base), right, line);
          line += LS;
        }

        // Mostrar impuestos por porcentaje (formato genérico)
        if (breakdown.tax_5 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Impuesto 5%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.tax_5), right, line);
          line += LS;
        }

        if (breakdown.tax_8 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Impuesto 8%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.tax_8), right, line);
          line += LS;
        }

        if (breakdown.tax_19 > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Impuesto 19%", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(breakdown.tax_19), right, line);
          line += LS;
        }

        // Descuentos si existen
        if (breakdown.total_discount > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Descuento aplicado", left, line);
          ctx.textAlign = "end";
          ctx.fillText(
            "(" + this.formatAmount(breakdown.total_discount) + ")",
            right,
            line
          );
          line += LS;
        }

        // Total final
        ctx.textAlign = "start";
        // ✅ NUEVO: Etiqueta dinámica según tipo de documento
        if ((data.document && data.document.doc_type) === "OP") {
          ctx.fillText("TOTAL COSTO", left, line);
        } else {
          ctx.fillText("TOTAL", left, line);
        }
        ctx.textAlign = "end";
        var grandTotal =
          breakdown.total_base + breakdown.total_tax - breakdown.total_discount;
        // ✅ ARREGLO: Usar formatCurrency para el total
        ctx.fillText(this.formatCurrency(grandTotal), right, line);
        line += LS;

        // Forma de pago
        line += LS;
        ctx.textAlign = "start";
        ctx.fillText("Forma de pago: CONTADO", left, line);
        line += LS;

        // ✅ ARREGLO: Mostrar métodos de pago con formatCurrency
        if (data.payments && data.payments.length > 0) {
          data.payments.forEach((payment) => {
            ctx.textAlign = "start";
            ctx.fillText(
              payment.payment_concept + " " + (payment.payment_reference || ""),
              left,
              line
            );
            ctx.textAlign = "end";
            ctx.fillText(this.formatCurrency(payment.payment_value), right, line);
            line += LS;
          });
        }

        line += LS;

        // Footer
        ctx.textAlign = "center";
        ctx.fillText("¡Gracias por su compra!", center, line);
        line += LS;

        // CUFE si existe
        if (data.document && data.document.cufe) {
          ctx.textAlign = "center";
          const result = data.document.cufe.match(/.{1,38}/g) || [];
          ctx.font = normalFont;
          ctx.fillText("CUFE:", center, line);
          line += 35;
          result.forEach((itm) => {
            ctx.fillText(itm, center, line);
            line += 35;
          });

          // Guardar posición para QR y generar QR integrado en el canvas
          const qrY = line + 20;
          line += 420; // Espacio para QR

          QRCode.toDataURL(url_cufe + data.document.cufe, (err, url) => {
            this.urlCufe = url; // Mantener para compatibilidad

            // Crear imagen y dibujarla en el canvas
            const qrImg = new Image();
            qrImg.onload = () => {
              // Dibujar QR dentro del canvas
              ctx.drawImage(qrImg, center - 200, qrY, 400, 400);

              // Guardar resultado final con QR integrado
              this.invoiceImg = elem.toDataURL();
              this.loading_status = false;
            };
            qrImg.src = url;
          });
        } else {
          // Si no hay CUFE, guardar imagen directamente
          this.invoiceImg = elem.toDataURL();
          this.loading_status = false;
        }
      } catch (error) {
        console.error("Error generando la imagen:", error);
        this.loading_status = false;
      }
    },
  },

  watch: {
    item: {
      handler(newItem) {
        if (newItem && Object.keys(newItem).length > 0) {
          this.print_invoice(newItem);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
/* ✅ ARREGLO: Estilos consistentes con doc_viewer.vue */
.navigation-drawer {
  z-index: 1000;
}

.fixed-footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
}

/* Asegurar que las imágenes se vean bien */
.v-img {
  border-radius: 4px;
}

/* Botón de impresión destacado */
.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>
